import { createSelector } from 'reselect';

// Direct selectors - more efficient than the redundant selectAthletesState
export const selectAthletes = createSelector(
  state => state.athletes.athletes,
  athletes => athletes
);

export const selectAthletesIsLoading = createSelector(
  [state => state.athletes.isLoadingAthletes, state => state.athletes.isLoadingAthlete],
  (isLoadingAthletes, isLoadingAthlete) => isLoadingAthletes || isLoadingAthlete
);

export const selectAthletesIsLoadingAthletes = createSelector(
  state => state.athletes.isLoadingAthletes,
  isLoadingAthletes => isLoadingAthletes
);

export const selectAthletesIsLoadingAthlete = createSelector(
  state => state.athletes.isLoadingAthlete,
  isLoadingAthlete => isLoadingAthlete
);

export const selectAthletesIsRemovingAthlete = createSelector(
  state => state.athletes.isRemovingAthlete,
  isRemovingAthlete => isRemovingAthlete
);

export const selectSelectedAthlete = createSelector(
  state => state.athletes.selectedAthlete,
  selectedAthlete => selectedAthlete
);

export const selectedAthleteTargetWeights = createSelector(
  state => state.athletes.selectedAthleteTargetWeights,
  selectedAthleteTargetWeights => selectedAthleteTargetWeights
);
